<template>
    <basic-container>
        <el-form ref="formData" :model="formData" :rules="rules" label-width="100px" :show-message="true" size="small">
            <!-- 上传商品主图 -->
            <el-row>
                <el-col :span="8">
                    <el-form-item label="商品主图" prop="mainImage">
                        <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                            :file-list="fileList0" :http-request="fnUploadMainImage" :show-file-list="false">
                            <div v-if="formData.mainImage != '' && formData.mainImage != null"
                                class="el-upload el-upload--picture-img">
                                <img :src="formData.mainImage" style="width: 200px;height: 200px;"
                                    @click.stop="mainImageDialogVisible = true">
                                <a style="color: red;" @click.stop="deleteMain(formData.mainImage)">删除</a>
                            </div>
                            <div v-else class="el-upload el-upload--car-two">
                                <i class="el-icon-plus"></i>
                            </div>
                            <div class="el-upload__tip">只能上传一张jpg/png</div>
                        </el-upload>
                        <el-dialog :visible.sync="mainImageDialogVisible">
                            <img width="100%" :src="formData.mainImage" alt>
                        </el-dialog>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="商品名称" prop="name">
                        <el-input v-model="formData.name" placeholder="请填写商品名称"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 选择商品单位 -->
                <el-col :span="8">
                    <el-form-item label="单位" prop="unit">
                        <el-input v-model="formData.unit" placeholder="请填写单位"></el-input>
                    </el-form-item>
                </el-col>
                <!-- 请选择品牌 -->
                <el-col :span="8">
                    <el-form-item label="品牌" prop="brandId">
                        <el-select v-model="formData.brandId" placeholder="请选择品牌">
                            <el-option v-for="item in brands" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <!-- 选择一级分类 -->
                <el-col :span="8">
                    <el-form-item label="一级分类" prop="firstClassifyId">
                        <el-select v-model="formData.firstClassifyId" placeholder="请选择一级分类" required
                            @change="getSecondClassify" clearable value-key="id">
                            <el-option v-for="classify in classifies" :key="classify.id" :label="classify.name"
                                :value="classify.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- 选择二级分类 -->
                <el-col :span="8">
                    <el-form-item label="二级分类">
                        <el-select v-model="formData.secondClassifyId" placeholder="请选择二级分类" required value-key="id"
                            clearable @change="getSkusList">
                            <el-option v-for="secondClassify in secondClassifies" :key="secondClassify.id"
                                :label="secondClassify.name" :value="secondClassify.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- 选择sku组合 -->
                <el-col :span="8">
                    <el-form-item label="sku组合">
                        <el-select v-model="formData.skuId" placeholder="请选择sku组合" required value-key="id" clearable
                            @change="findConstituteBySkuId">
                            <el-option v-for="sku in skuList" :key="sku.id" :label="sku.skuName" :value="sku.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- SKU的表格输入 -->
            <el-row>
                <el-col :span="24">
                    <el-table :data="constitutes" border stripe height="400" max-height="600">
                        <template>
                            <el-table-column v-for="(col, index) in tableData1" sortable :show-overflow-tooltip="true"
                                :prop="col.dataItem" :label="col.dataName" :key="col.dataItem" width="124px">
                                <template slot-scope="scope">
                                    <!-- 如果是img，那么需要上传sku图片（单张），每一个循环出来的都需要上传sku图片 -->
                                    <div v-if="col.isImage && col.dataName == 'SKU图片'">
                                        <el-upload
                                            :file-list="scope.row[col.flag] ? [{ url: scope.row[col.flag] }] : []"
                                            action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                                            :http-request="(option) => fnUploadSkuImage(option, scope.$index, col.flag)"
                                            :show-file-list="false">
                                            <el-button type="sucess" icon="el-icon-upload" size="mini"
                                                v-if="!scope.row[col.flag]">点击上传</el-button>
                                        </el-upload>
                                        <div v-if="scope.row[col.flag]">
                                            <img :src="scope.row[col.flag]" style="width: 50px; height: 50px;">
                                            <el-button type="text" size="small"
                                                @click="deleteSkuImage(scope.$index, col.flag)">删除</el-button>
                                        </div>
                                    </div>
                                    <el-input type="input" v-if="col.dataName == '入库量'" :disabled="col.disabled"
                                        :name="col.dataName" v-model="scope.row[index]" :placeholder="col.placeholder"
                                        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                    </el-input>
                                    <el-input type="input" v-else-if="col.dataName !=='SKU图片'" :disabled="col.disabled" :name="col.dataName"
                                        v-model="scope.row[index]" :placeholder="col.placeholder">
                                    </el-input>
                                </template>
                            </el-table-column>
                        </template>

                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button plain type="danger" icon="el-icon-delete" size="small"
                                    @click="handleSteppingDelete(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 20px">
                        <el-button size="small" type="success" icon="el-icon-plus" @click="handleAddRows()"
                            plain>增加一行</el-button>
                    </div>
                </el-col>
            </el-row>
            <!-- 商品状态 -->
            <el-row>
                <el-col :span="8">
                    <el-form-item label="商品状态" prop="status">
                        <el-radio v-model="formData.status" label="SOLD_IN">上架</el-radio>
                        <el-radio v-model="formData.status" label="SOLD_OUT">下架</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <!-- 上传产品轮播图 -->
                <el-col :span="12">
                    <el-form-item label="商品轮播图" prop="wheels">
                        <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                            :file-list="fileList2" :http-request="fnUploadWheelsImgs" :show-file-list="false">
                            <div v-if="formData.wheels != '' && formData.wheels != null"
                                class="el-upload el-upload--picture-img">
                                <div :key="wheelImg.id" v-for="wheelImg of formData.wheels">
                                    <img style="width: 200px;height: 200px;" :src="wheelImg"
                                        @click.stop="wheelsDialogVisible = true" />
                                    <a style="color: red;" @click.stop="deleteWhell(wheelImg)">删除</a>
                                </div>
                            </div>
                            <div v-else class="el-upload el-upload--car-two">
                                <i class="el-icon-plus"></i>
                            </div>
                            <div class="el-upload__tip">只能上传jpg/png</div>
                        </el-upload>
                        <el-dialog :visible.sync="wheelsDialogVisible">
                            <img width="100%" :src="formData.wheels" alt>
                        </el-dialog>
                    </el-form-item>
                </el-col>
                <!-- 上传商品描述详情图 -->
                <el-col :span="12">
                    <el-form-item label="商品详情图" prop="describes">
                        <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                            :file-list="fileList1" :http-request="fnUploadDescribeImgs" :show-file-list="false">
                            <div v-if="formData.describes != '' && formData.describes != null"
                                class="el-upload el-upload--picture-img">
                                <div :key="describeImg.id" v-for="describeImg of formData.describes">
                                    <img style="width: 200px;height: 200px;" :src="describeImg"
                                        @click.stop="describesDialogVisible = true" />
                                    <a style="color: red;" @click.stop="deleteDes(describeImg)">删除</a>
                                </div>
                            </div>
                            <div v-else class="el-upload el-upload--car-two">
                                <i class="el-icon-plus"></i>
                            </div>
                            <div class="el-upload__tip">只能上传一张jpg/png</div>
                        </el-upload>
                        <el-dialog :visible.sync="describesDialogVisible">
                            <img width="100%" :src="formData.describes" alt>
                        </el-dialog>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-form-item style="padding: 20px;display: flex;justify-content: center;border-top: 2px solid #ebeef5;">
                    <!-- 保存编辑信息 -->
                    <el-button v-if="formData.isEdits" type="primary" icon="el-icon-edit"
                        @click="handleUpdate('formData')" plain>保存</el-button>
                    <el-button v-else type="primary" icon="el-icon-plus" @click="onSubmit('formData')"
                        plain>新增</el-button>
                    <el-button type="danger" icon="el-icon-close" plain @click="() => { $router.go(-1) }">取消</el-button>
                </el-form-item>
            </el-row>
        </el-form>

    </basic-container>
</template>
<script>
import {
    findBrand,
    findClassify,
    chooseSecondClassify,
    chooseFirstSku,
    findProductSkuClassify,
    findConstituteBySkuId,
    invoiceSystemV2PutAdd,
    invoiceSystemV2PutEdit
} from "@/api/salesCloud/stockGoods";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
export default {
    data() {
        return {
            formData: {
                name: '',//商品名称
                brandId: '',//品牌名称
                unit: '',//商品单位
                firstClassifyId: '',//一级分类名称
                secondClassifyId: '',//二级分类名称
                skuId: '',//sku组合id
                mainImage: '',//商品主图
                describes: [],//商品描述详情图
                wheels: [],//商品轮播图
                status: 'SOLD_IN',//商品状态
                isEdits: false,//是否编辑
                isEdit: false,//是否编辑
            },
            rules: {
                name: [
                    { required: true, message: '请输入商品名称', trigger: 'blur' }
                ],
                brandId: [
                    { required: true, message: '请选择品牌', trigger: 'change' }
                ],
                firstClassifyId: [
                    { required: true, message: '请选择一级分类', trigger: 'change' }
                ],
                secondClassifyId: [
                    { required: true, message: '请选择二级分类', trigger: 'change' }
                ],
                skuId: [
                    { required: true, message: '请选择sku组合', trigger: 'change' }
                ],
                unit: [
                    { required: true, message: '请输入商品单位', trigger: 'blur' }
                ],
            },
            fileList0: [],//商品主图列表
            mainImageDialogVisible: false,//商品主图弹窗
            brands: [],//品牌列表
            classifies: [],//一级分类列表
            secondClassifies: [],//二级分类列表
            skuList: [],//商品sku列表
            tableData1: [],//sku组合列表
            constitutes: [],//sku组合
            fileList2: [],//商品轮播图列表
            wheelsDialogVisible: false,//商品轮播图弹窗
            fileList1: [],//商品描述详情图列表
            describesDialogVisible: false,//商品描述详情图弹窗
        }
    },
    methods: {
        /**
         * @description 上传商品主图，只能上传一张
         */
        async fnUploadMainImage(option) {
            this.tableLoading = true;
            getAliyunPublicToken().then(res => {
                let data = JSON.parse(res.data);
                let client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken
                });
                const storeAs = md5(option.file.name) + new Date().getTime();
                client
                    .multipartUpload(storeAs, option.file, {})
                    .then(results => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file);
                        }
                        this.fileList0 = files;
                        let array = results.res.requestUrls[0].split("?");
                        this.formData.mainImage = array[0];
                        this.tableLoading = false;
                    })
                    .catch(err => {
                        this.tableLoading = false;
                        this.$message({
                            showClose: true,
                            message: err,
                            type: "error"
                        });
                    });
            });
        },
        /**
         * @description 删除商品主图
         */
        deleteMain() {
            this.formData.mainImage = '';
            this.fileList0 = [];
        },
        /**
         * @description 获取二级分类数据
         */
        getSecondClassify(e) {
            var that = this;
            // console.log(e);
            that.formData.firstClassifyId = e;
            if (e == undefined || e == '') {
                that.formData.secondClassifyId = '';
                that.formData.skuId = '';
                that.skuList = [];
                that.secondClassifies = [];
                return
            } else {
                chooseSecondClassify(e).then((res) => {
                    let data = JSON.parse(res.data);
                    that.secondClassifies = data;
                });
                /**
                 * @description 获取商品sku
                 */
                chooseFirstSku(e).then((res) => {
                    let data = JSON.parse(res.data);
                    that.skuList = data;
                });
            }

        },
        /**
         * @description 获取商品sku
         */
        getSkusList(e) {
            var that = this;
            that.formData.skuId = '';
            that.skuList = [];
            let obj = {};
            obj.firstClassifyId = that.formData.firstClassifyId;
            obj.secondClassifyId = e;
            that.formData.secondClassifyId = e;
            // console.log(e);
            if (e == undefined || e == '') {
                delete obj.secondClassifyId;
            }
            // console.log(obj);
            findProductSkuClassify(obj).then((res) => {
                let data = JSON.parse(res.data);
                that.skuList = data;
            });
        },
        /**
         * @description 获取sku组合
         */
        findConstituteBySkuId(e) {
            var that = this;
            that.formData.skuId = e;
            if (e == undefined || e == '') {
                return
            }
            findConstituteBySkuId(e).then((res) => {
                let data = JSON.parse(res.data);
                // console.log(data);
                that.formatConstitute(data, false);
            });
        },
        /**
         * @description 格式化sku组合
         */
        formatConstitute(data, isEdits) {
            let flag = 0;
            this.tableData1 = new Array(data.length + 4);
            for (let i = 0; i < data.length; i++) {
                let obj = {};
                obj.dataItem = data[i].constituteCode;
                obj.dataName = data[i].constituteName;
                obj.placeholder = data[i].constituteName;
                obj.id = data[i].id;
                obj.flag = flag;
                this.tableData1[flag] = obj;
                flag++;
            }
            this.tableData1[flag] = {
                dataItem: "stockPrice",
                dataName: "进货价",
                placeholder: "进货价",
                flag: flag,
                disabled: false,
            };
            this.tableData1[flag + 1] = {
                dataItem: "purchasePrice",
                dataName: "采购价",
                placeholder: "采购价",
                flag: flag + 1,
                disabled: false,
            };
            this.tableData1[flag + 2] = {
                dataItem: "salePrice",
                dataName: "零售价",
                placeholder: "零售价",
                flag: flag + 2,
                disabled: false,
            };
            this.tableData1[flag + 3] = {
                dataItem: "amount",
                dataName: isEdits ? "库存" : "入库量",
                placeholder: isEdits ? "库存" : "入库量",
                flag: flag + 3,
                disabled: isEdits ? true : false,
            };
            // 为SKU图片上传添加标记
            this.tableData1.push({
                dataItem: "img",
                dataName: "SKU图片",
                flag: this.tableData1.length,
                isImage: true, // 添加标记，用于区分图片上传列
            });
            // 初始化constitutes数据，为每个SKU项添加img字段
            this.constitutes.forEach((sku) => {
                sku.img = '';
            });
        },
        /**
         * @description 上传sku图片
         */
        async fnUploadSkuImage(option, rowIndex, colIndex) {
            this.tableLoading = true;
            getAliyunPublicToken().then(res => {
                let data = JSON.parse(res.data);
                let client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken
                });
                const storeAs = md5(option.file.name) + new Date().getTime();
                client.multipartUpload(storeAs, option.file, {})
                    .then(results => {
                        let res = results.res.requestUrls;
                        let array = res[0].split("?");
                        let url = array[0];
                        this.$set(this.constitutes[rowIndex], colIndex, url); // 更新对应SKU项的图片字段
                        this.tableLoading = false;
                    })
                    .catch(err => {
                        this.tableLoading = false;
                        this.$message({
                            showClose: true,
                            message: err,
                            type: "error"
                        });
                    });
            });
        },
        /**
         * @description 删除sku图片
         */
        deleteSkuImage(rowIndex, colIndex) {
            this.$set(this.constitutes[rowIndex], colIndex, '');
        },
        /**
         * @description 增加一行
         */
        handleAddRows() {
            // 如果sku组合为空，不允许增加一行
            if (this.formData.skuId == '') {
                this.$message({
                    message: '请先选择sku组合',
                    type: 'warning'
                });
                return;
            }
            let obj = "{";
            for (let i = 0; i < this.tableData1.length; i++) {
                if (i != this.tableData1.length - 1) {
                    obj += "" + i + ":'',";
                } else {
                    obj += "" + i + ":''";
                }
            }
            obj += "}";
            let dataObj = eval("(" + obj + ")");
            this.constitutes.push(dataObj);
        },
        /**
         * @description 删除一行
         */
        handleSteppingDelete(index) {
            this.constitutes.splice(index, 1);
            this.dataSku1.splice(index, 1);
        },
        /**
         * @description 上传商品轮播图,不限制张数
         */
        async fnUploadWheelsImgs(option) {
            if (this.formData.wheels.length >= 5) {
                this.$message({
                    showClose: true,
                    message: "轮播图不能超过五张",
                    type: "error",
                });
                return;
            }
            this.tableLoading = true;
            getAliyunPublicToken().then((res) => {
                let data = JSON.parse(res.data);
                let client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });
                const storeAs = md5(option.file.name) + new Date().getTime();
                client
                    .multipartUpload(storeAs, option.file, {})
                    .then((results) => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file);
                        }
                        this.fileList1 = files;
                        let array = results.res.requestUrls[0].split("?");
                        this.formData.wheels.push(array[0]);
                        this.tableLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },
        /**
         * @description 删除商品轮播图
         */
        deleteWhell(e) {
            let index = this.formData.wheels.indexOf(e);
            this.formData.wheels.splice(index, 1);
            this.fileList2.splice(index, 1);
        },
        /**
         * @description 上传商品描述详情图,不限制张数
         */
        async fnUploadDescribeImgs(option) {
            this.tableLoading = true;
            getAliyunPublicToken().then((res) => {
                let data = JSON.parse(res.data);
                let client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });
                const storeAs = md5(option.file.name) + new Date().getTime();
                client
                    .multipartUpload(storeAs, option.file, {})
                    .then((results) => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file);
                        }
                        this.fileList1 = files;
                        let array = results.res.requestUrls[0].split("?");
                        this.formData.describes.push(array[0]);
                        this.tableLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },
        /**
         * @description 删除商品描述详情图
         */
        deleteDes(e) {
            let index = this.formData.describes.indexOf(e);
            this.formData.describes.splice(index, 1);
            this.fileList1.splice(index, 1);
        },
        /** 
         * @description 新增商品入库
         */
        onSubmit(formName) {
            var that = this;
            let params = {};
            let dataSku = [];
            for (let i = 0; i < that.constitutes.length; i++) {
                let obj = that.constitutes[i];
                let strMap = new Map();
                for (let k of Object.keys(obj)) {
                    strMap.set(k, obj[k]);
                }
                // console.log(strMap)
                let ids = "";
                let val = "";
                let skuMap = new Map();
                for (let j = 0; j < that.tableData1.length; j++) {
                    let obj1 = that.tableData1[j];
                    // console.log(obj1)
                    if (typeof obj1.id != "undefined") {
                        ids += obj1.id + ":";
                        val += strMap.get(j + "") + ":";
                    } else {
                        skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
                    }
                }
                let sku = Object.create(null);
                for (let [k, v] of skuMap) {
                    sku[k] = v;
                }
                ids = ids.substring(0, ids.length - 1);
                val = val.substring(0, val.length - 1);
                sku.skuKey = ids;
                sku.skuValue = val;
                sku.skuId = that.formData.skuId;
                dataSku.push(sku);
            }
            params.skus = dataSku;
            // 将表单数据和sku组合数据合并
            params = Object.assign(params, that.formData);
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    // console.log(valid);
                    // console.log(params);
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'warning'
                    });
                    return false;
                }
            });
            invoiceSystemV2PutAdd(params)
                .then((res) => {
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success",
                        });
                        // 返回上一页
                        this.$router.go(-1);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "error",
                        });

                    }
                })
        },
        /**
        * @description 初始化编辑回显数据
        */

        initEdit(row, index, isEdits) {
            // console.log(row);
            var that = this;
            that.formData.isEdit = true;
            that.formData.brandId = row.brandId; //品牌名称回显
            that.formData.firstClassifyId = row.firstClassifyId; //一级分类回显
            //二级分类回显
            chooseSecondClassify(that.formData.firstClassifyId).then((res) => {
                let data = JSON.parse(res.data);
                that.secondClassifies = data;
                that.formData.secondClassifyId = row.secondClassifyId;
            });
            //sku组合回显
            let obj = {};
            obj.firstClassifyId = row.firstClassifyId;
            obj.secondClassifyId = row.secondClassifyId;
            findProductSkuClassify(obj).then((res) => {
                let data = JSON.parse(res.data);
                that.skuList = data;
                that.formData.skuId = row.skuId;
                findConstituteBySkuId(row.skuId).then((res) => {
                    let adata = JSON.parse(res.data);
                    that.formatConstitute(adata, isEdits);
                    // console.log(row.obj);
                    for (let item of row.obj) {
                        let skuLenght = item.skuValue.split(":");
                        skuLenght.push(item.stockPrice + "");
                        skuLenght.push(item.purchasePrice + "");
                        skuLenght.push(item.salePrice + "");
                        skuLenght.push(item.amount + "");
                        // 图片回显
                        skuLenght.push(item.img);
                        skuLenght.push(item.id?item.id:'');
                        let obj = Object.assign({}, skuLenght);
                        that.constitutes.push(obj);
                        // console.log(that.formData.constitutes);
                    }
                });
            });
            that.formData.name = row.name;
            that.formData.unit = row.unit;
            that.formData.status = row.status;
            that.formData.mainImage = row.mainImage;
            that.formData.wheels = row.wheels;
            that.formData.describes = row.describes;

        },
        /**
         * @description 保存编辑
         */
        handleUpdate(formName) {
            let params = {};
            let dataSku = [];
            // console.log(this.constitutes);
            // console.log(this.tableData1.length);
            for (let i = 0; i < this.constitutes.length; i++) {
                let obj = this.constitutes[i];
                let strMap = new Map();
                for (let k of Object.keys(obj)) {
                    strMap.set(k, obj[k]);
                }
                // console.log(strMap)
                let ids = "";
                let val = "";
                let skuMap = new Map();
                for (let j = 0; j < this.tableData1.length; j++) {
                    let obj1 = this.tableData1[j];
                    // console.log(obj1)
                    if (typeof obj1.id != "undefined") {
                        ids += obj1.id + ":";
                        val += strMap.get(j + "") + ":";
                    } else {
                        skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
                    }
                }
                let sku = Object.create(null);
                for (let [k, v] of skuMap) {
                    sku[k] = v;
                }
                // console.log(this.tableData1);
                ids = ids.substring(0, ids.length - 1);
                val = val.substring(0, val.length - 1);
               // console.log(this.constitutes[i]);
               let id = this.constitutes[i][this.tableData1.length]?this.constitutes[i][this.tableData1.length]:'';
                sku.skuKey = ids;
                sku.skuValue = val;
                sku.skuId = this.formData.skuId;
                sku.id = id;
                sku.amount = '0';
                // console.log(sku);
                dataSku.push(sku);
            }
            params.skus = dataSku;
            params.id = this.$route.query.row.id;
            params = Object.assign(params, this.formData);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // console.log(valid);
                    // console.log(params);
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'warning'
                    });
                    return false;
                }
            });
            // console.log(params);
            invoiceSystemV2PutEdit(params)
                .then((res) => {
                    // console.log(res);
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "修改成功",
                            type: "success",
                        });
                        // 返回上一页
                        this.$router.go(-1);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "error",
                        });
                    }
                })
                .catch((error) => {
                    this.tableLoading = false;
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error",
                    });
                });
        },
    },
    // 初始化
    created() {
        var that = this;
        //获取是否isEdits
        if (this.$route.query.isEdits) {
            that.formData.isEdits = this.$route.query.isEdits;
            that.initEdit(this.$route.query.row, this.$route.query.index, this.$route.query.isEdits);
        }
        // 获取品牌列表
        findBrand().then((res) => {
            let data = JSON.parse(res.data);
            that.brands = data.rows;
        });
        // 获取一级分类列表
        findClassify().then((res) => {
            let data = JSON.parse(res.data);
            that.classifies = data;
        });
    },
    mounted() {
        // console.log(this.$route.query);
    }
}
</script>
<style lang="scss" scoped>
el-form-item__content {
    display: flex;
}
</style>